const SESSION_KEYS = [
    'MY_APP_STATE_USER',
    'MY_APP_STATE_APIKEY',
    'MY_APP_STATE_AUTHCODE',
    'MY_APP_STATE_ROLE',
    'MY_APP_STATE_PROF_ID',
    'MY_APP_STATE_PROF_NAME',
    'MY_APP_STATE_PROF_PROF',
    'MY_APP_STATE_PROV_VALOR',
    'MY_APP_STATE_PROF_CASINO',
    'MY_APP_STATE_PROF_CASINO_ID',
    'MY_APP_STATE_PROF_TIENE_IMPRESORA',
    'MY_APP_STATE_PROF_IMPRESORA'
]

export const IMPERSONATION_SOURCE_KEY = 'MY_APP_STATE_IMPERSONATION_SOURCE'
export const IMPERSONATION_ACTIVE_KEY = 'MY_APP_STATE_IMPERSONATION_ACTIVE'
export const IMPERSONATION_RETURN_PATH_KEY = 'MY_APP_STATE_IMPERSONATION_RETURN_PATH'

function writeSessionValue(storage, key, value)
{
    if(value === undefined)
    {
        storage.removeItem(key)
        return
    }

    storage.setItem(key, JSON.stringify(value))
}

export function clearImpersonationState()
{
    if(typeof window === 'undefined')
    {
        return
    }

    window.localStorage.removeItem(IMPERSONATION_SOURCE_KEY)
    window.localStorage.removeItem(IMPERSONATION_ACTIVE_KEY)
    window.localStorage.removeItem(IMPERSONATION_RETURN_PATH_KEY)
}

export function snapshotCurrentSession(returnPath = '')
{
    if(typeof window === 'undefined')
    {
        return
    }

    const snapshot = SESSION_KEYS.reduce((accumulator, key) => {
        const currentValue = window.localStorage.getItem(key)

        if(currentValue !== null)
        {
            accumulator[key] = currentValue
        }

        return accumulator
    }, {})

    window.localStorage.setItem(IMPERSONATION_SOURCE_KEY, JSON.stringify(snapshot))
    window.localStorage.setItem(IMPERSONATION_ACTIVE_KEY, 'true')

    if(returnPath !== '')
    {
        window.localStorage.setItem(IMPERSONATION_RETURN_PATH_KEY, returnPath)
    }
}

export function applySessionData(userMail, sessionData)
{
    if(typeof window === 'undefined')
    {
        return
    }

    const storage = window.localStorage
    const profile = sessionData?.perfil || {}

    writeSessionValue(storage, 'MY_APP_STATE_USER', userMail)
    writeSessionValue(storage, 'MY_APP_STATE_APIKEY', sessionData?.ApiKey)
    writeSessionValue(storage, 'MY_APP_STATE_AUTHCODE', sessionData?.AuthCode)
    writeSessionValue(storage, 'MY_APP_STATE_ROLE', sessionData?.roles || [])
    writeSessionValue(storage, 'MY_APP_STATE_PROF_ID', profile.id_perfil)
    writeSessionValue(storage, 'MY_APP_STATE_PROF_NAME', profile.fullname)
    writeSessionValue(storage, 'MY_APP_STATE_PROF_PROF', profile.perfil)
    writeSessionValue(storage, 'MY_APP_STATE_PROV_VALOR', profile.valor_ticket)
    writeSessionValue(storage, 'MY_APP_STATE_PROF_CASINO', profile.casino)
    writeSessionValue(storage, 'MY_APP_STATE_PROF_CASINO_ID', profile.casino_id)
    writeSessionValue(storage, 'MY_APP_STATE_PROF_TIENE_IMPRESORA', profile.tiene_impresora)
    writeSessionValue(storage, 'MY_APP_STATE_PROF_IMPRESORA', profile.impresora)
}

export function restoreImpersonatedSession()
{
    if(typeof window === 'undefined')
    {
        return ''
    }

    const storage = window.localStorage
    const snapshotRaw = storage.getItem(IMPERSONATION_SOURCE_KEY)
    const returnPath = storage.getItem(IMPERSONATION_RETURN_PATH_KEY) || ''

    if(snapshotRaw == null)
    {
        clearImpersonationState()
        return returnPath
    }

    let snapshot = {}

    try
    {
        snapshot = JSON.parse(snapshotRaw) || {}
    }
    catch(error)
    {
        snapshot = {}
    }

    SESSION_KEYS.forEach((key) => {
        if(Object.prototype.hasOwnProperty.call(snapshot, key))
        {
            storage.setItem(key, snapshot[key])
        }
        else
        {
            storage.removeItem(key)
        }
    })

    clearImpersonationState()
    return returnPath
}

export function isImpersonating()
{
    if(typeof window === 'undefined')
    {
        return false
    }

    return window.localStorage.getItem(IMPERSONATION_ACTIVE_KEY) === 'true'
}

export function getDefaultSessionPath(roles)
{
    if(Array.isArray(roles) && roles.length > 0 && roles[0]?.path)
    {
        return roles[0].path
    }

    return '/Home'
}
